import { HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

export const AREA_LABEL_VARIANT = {
  Community: 'Community',
  Emotions: 'Emotions',
  Work: 'Work',
  Finances: 'Finances',
  Relationships: 'Relationships',
  Health: 'Health',
} as const;

export type AreaLabelVariant = keyof typeof AREA_LABEL_VARIANT;

export const variantClasses: Record<AreaLabelVariant, string> = {
  Community: 'bg-[#FF0083]',
  Emotions: 'bg-[#9B00E3]',
  Relationships: 'bg-[#005EFF]',
  Work: 'bg-[#00A7BD]',
  Finances: 'bg-[#00C431]',
  Health: ' bg-[#FCB205]',
};

export interface AreaLabelProps extends HTMLAttributes<HTMLDivElement> {
  variant: AreaLabelVariant;
}

const AreaLabel = ({ variant, className }: AreaLabelProps) => {
  return (
    <div
      className={twMerge(
        'p-0.25 font-manrope block whitespace-nowrap text-sm font-medium leading-5 text-gray-800',
        className,
      )}
    >
      {AREA_LABEL_VARIANT[variant]}
    </div>
  );
};

export default AreaLabel;
